import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from 'api/endpoint';

export interface Account extends AttributesMixin<typeof Account> { }

@define
export class Account extends Model {
  static endpoint = restfulIO('/api/v1/incash/cash-balance/accounts');

  static attributes = {    
    id: String,
    label: String
  }
}